// extracted by mini-css-extract-plugin
module.exports = {"readMore":"ReadMoreWithRichText_readMore__5yvZG"};